// CustomFilter.tsx
import React, {useState, useImperativeHandle, forwardRef, useEffect, useCallback} from 'react';
import {IFilterComp, IFilterParams, IDoesFilterPassParams} from 'ag-grid-community';
import Button from '../Button';
import {TextField} from 'material-ui';
interface RatingFilterProps extends IFilterParams {
    dataSource: any[];
    width: string;
    filterKey: string;
}
interface RatingFilterModel {
    filterText: string;
}

const RatingFilter = forwardRef<Partial<IFilterComp>, RatingFilterProps>((props, ref) => {
    const [filterText, setFilterText] = useState<string>('Please select');
    const [range, setRange] = useState<any>(0);
    const dataSource = props.dataSource || [];

    // Mark filter as active if filterText has content
    const isFilterActive = () => filterText !== '';

    // Define the filter logic
    const doesFilterPass = useCallback(
        (params: IDoesFilterPassParams) => {
            const {colDef} = props;

            const value = params.data[colDef.field as string];
            if (props.filterKey && filterText && range > 0) {
                if (+filterText === 1) {
                    return value.some((v: any) => v[props.filterKey] > range);
                } else if (+filterText === 2) {
                    return value.some((v: any) => v[props.filterKey] < range);
                } else if (+filterText === 3) {
                    return value.some((v: any) => v[props.filterKey] === range);
                }
            }
            return true;
        },
        [filterText, props, range]
    );

    useImperativeHandle(
        ref,
        () =>
        // @ts-ignore
        ({
            isFilterActive,
            doesFilterPass,
            getModel: () => (filterText ? {filterText, range} : null),
            setModel: (model: RatingFilterModel | null) => setFilterText(model ? model.filterText : filterText)
        }));
    // Clear the filter
    const clearFilter = () => {
        setFilterText(''); // Reset the filter text to empty
        setRange(0);
        setTimeout(
            () => {
                props.api.setFilterModel(null); // Remove the filter model to clear the filter icon
                props.filterChangedCallback(); // Force AG Grid to re-evaluate filters
            });
    };
    // Update the filter text and trigger AG Grid's filter callback
    const onFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setFilterText(value);
        if (value) {
            setTimeout(
                () => {
                    props.filterChangedCallback(); // Force AG Grid to re-evaluate filters
                });
        }
    };
    const onRatingChange = (e: React.ChangeEvent<HTMLSelectElement>, newValue: string) => {
        if(newValue === '') {
            setRange('');
            return;
        }
        setRange(+newValue);
        if (newValue) {
            setTimeout(
                () => {
                    props.filterChangedCallback(); // Force AG Grid to re-evaluate filters
                });
        }
    };

    return (
        <div className='select-filter-container'>
            {dataSource.length > 0 && (
                <div className='rating-filter-container'>
                    <select
                        className="select-filter"
                        style={{width: props.width}}
                        value={filterText} // Bind value to state to keep in sync
                        onChange={onFilterChange}
                    >
                        <option value="">Please select</option>
                        {dataSource.map((item) => (
                            <option key={item.key} value={item.value}>
                                {item.text}
                            </option>
                        ))}
                    </select>
                   <TextField style={{width:'100px'}} value={range} onChange={onRatingChange} />
                </div>

            )}

            <Button
                icon='close'
                className='close-filter'
                onClick={clearFilter}
            />
        </div>
    );
});

export default RatingFilter;



// WEBPACK FOOTER //
// ./src/components/kuma/RatingFilter.tsx